export const CREATE_LOCATION = "CREATE_LOCATION";
export const CREATE_LOCATION_SUCCESS = "CREATE_LOCATION_SUCCESS";
export const CREATE_LOCATION_ERROR = "CREATE_LOCATION_ERROR";
const UPDATE_LOCATION = "UPDATE_LOCATION";
const UPDATE_LOCATION_SUCCESS = "UPDATE_LOCATION_SUCCESS";
const UPDATE_LOCATION_ERROR = "UPDATE_LOCATION_ERROR";
const FETCH_LOCATION = "FETCH_LOCATION";
const FETCH_LOCATION_SUCCESS = "FETCH_LOCATION_SUCCESS";
const FETCH_LOCATION_ERROR = "FETCH_LOCATION_ERROR";
const LOCATION_DETAILS_IS_EDIT = "LOCATION_DETAILS_IS_EDIT";
const FETCH_ALL_LOCATIONS = "FETCH_ALL_LOCATIONS";
const FETCH_ALL_LOCATIONS_SUCCESS = "FETCH_ALL_LOCATIONS_SUCCESS";
const FETCH_ALL_LOCATIONS_ERROR = "FETCH_ALL_LOCATIONS_ERROR";
const DELETE_LOCATION = "DELETE_LOCATION";
const DELETE_LOCATION_SUCCESS = "DELETE_LOCATION_SUCCESS";
const DELETE_LOCATION_ERROR = "DELETE_LOCATION_ERROR";
const DELETE_LOCATION_ATTACH = "DELETE_LOCATION_ATTACH";
const DELETE_LOCATION_ATTACH_SUCCESS = "DELETE_LOCATION_ATTACH_SUCCESS";
const DELETE_LOCATION_ATTACH_ERROR = "DELETE_LOCATION_ATTACH_ERROR";
const LOCATION_NOTIF_IS_EDIT = "LOCATION_NOTIF_IS_EDIT";
const LOCATION_DETAIL_CLEANUP_FUNC = "LOCATION_DETAIL_CLEANUP_FUNC";
const UPDATE_LOCATION_NOTIFICATION = "UPDATE_LOCATION_NOTIFICATION";
const UPDATE_LOCATION_NOTIFICATION_SUCCESS = "UPDATE_LOCATION_NOTIFICATION_SUCCESS";
const UPDATE_LOCATION_NOTIFICATION_ERROR = "UPDATE_LOCATION_NOTIFICATION_ERROR";

export {
  UPDATE_LOCATION,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_LOCATION_ERROR,
  FETCH_LOCATION,
  FETCH_LOCATION_SUCCESS,
  FETCH_LOCATION_ERROR,
  LOCATION_DETAILS_IS_EDIT,
  FETCH_ALL_LOCATIONS,
  FETCH_ALL_LOCATIONS_SUCCESS,
  FETCH_ALL_LOCATIONS_ERROR,
  DELETE_LOCATION,
  DELETE_LOCATION_SUCCESS,
  DELETE_LOCATION_ERROR,
  DELETE_LOCATION_ATTACH,
  DELETE_LOCATION_ATTACH_SUCCESS,
  DELETE_LOCATION_ATTACH_ERROR,
  LOCATION_NOTIF_IS_EDIT,
  LOCATION_DETAIL_CLEANUP_FUNC,
  UPDATE_LOCATION_NOTIFICATION,
  UPDATE_LOCATION_NOTIFICATION_SUCCESS,
  UPDATE_LOCATION_NOTIFICATION_ERROR,
};
